import React, { useCallback, useState } from "react";
import { TableHeaderColumn } from "react-bootstrap-table";
import Report from "../Report";
import {
  FormControl,
  FormControlLabel,
  Radio,
  RadioGroup,
  TextField,
} from "@material-ui/core";
import {
  dateReportFormatter,
  dateTimeReportFormatter,
  durationReportFormatter,
} from "../../fomatters/DateFormatter";
import InputSelect from "../InputSelect";
import { useDataFormatterHook } from "../../../hooks/useDataFormatterHook";
import SubGroup from "../SubGroup";

const currentDate = new Date();
currentDate.setDate(currentDate.getDate() - 7);

const startDateValue = currentDate.toISOString().split("T")[0];
const endDateValue = new Date().toISOString().split("T")[0];

/**
 * TABLE FREEPLAYOFFICEOPTIONS
 */
function SignOnStatus() {
  const [startDate, setStartDate] = useState(startDateValue);
  const onStartDateChange = useCallback(
    (event) => setStartDate(event.target.value),
    []
  );

  const [endDate, setEndDate] = useState(endDateValue);
  const onEndDateChange = useCallback(
    (event) => setEndDate(event.target.value),
    []
  );

  const [station, setStation] = useState("");
  const onStationChange = useCallback(
    (event) => setStation(event.target.value),
    []
  );

  const [user, setUser] = useState("");
  const onUserChange = useCallback((u) => setUser(u), []);
  const { values: users } = useDataFormatterHook({
    addEmpty: true,
    value: "loginName",
    text: "loginName",
    path: `/User/GetUsers`,
  });

  return (
    <div className="flex flex-col gap-4 p-4 h-max">
      <div className="grid grid-cols-2 gap-4">
        <TextField
          className="flex-1"
          required
          variant="outlined"
          id="gameDateTime"
          label="From"
          type="date"
          value={startDate}
          size="small"
          onChange={onStartDateChange}
          InputLabelProps={{ shrink: true }}
        />
        <TextField
          required
          variant="outlined"
          id="gameDateTime"
          label="To"
          type="date"
          value={endDate}
          size="small"
          onChange={onEndDateChange}
          InputLabelProps={{ shrink: true }}
        />
        <InputSelect
          variant="outlined"
          size="small"
          label="User"
          name="name"
          data={users}
          placeholder="DataFormatter"
          setSelectValue={onUserChange}
          startValue={""}
        />
        <TextField
          required
          variant="outlined"
          label="Station"
          type="text"
          value={station}
          size="small"
          onChange={onStationChange}
          InputLabelProps={{ shrink: true }}
        />
      </div>
      <Report
        title="Sign on Status Report"
        getUrl={() => "/Reports/Report_Sign_On_Status_2"}
        getParams={({ userId }) => ({
          IdUser: Number(userId),
          StartDate: startDate,
          EndDate: endDate,
          User: user,
          Station: station,
        })}
      >
        <TableHeaderColumn dataSort dataField="Id" isKey hidden>
          Id
        </TableHeaderColumn>
        <TableHeaderColumn dataSort dataField="loginName">
          User
        </TableHeaderColumn>
        <TableHeaderColumn dataSort dataField="system">
          System
        </TableHeaderColumn>
        <TableHeaderColumn dataSort dataField="phoneLine">
          Station
        </TableHeaderColumn>
        <TableHeaderColumn
          dataSort
          dataField="loginTime"
          dataFormat={dateTimeReportFormatter}
        >
          In
        </TableHeaderColumn>
        <TableHeaderColumn
          dataSort
          dataField="logoutTime"
          dataFormat={dateTimeReportFormatter}
        >
          Out
        </TableHeaderColumn>
        <TableHeaderColumn
          dataSort
          dataField="duration"
          dataFormat={durationReportFormatter}
        >
          Time
        </TableHeaderColumn>
      </Report>
    </div>
  );
}

export default SignOnStatus;
